/**
 * Place any polyfills here. This project uses core-js:
 * https://github.com/zloirock/core-js
 *
 * ES6:
 * https://github.com/zloirock/core-js/tree/master/es6
 */

require('core-js/modules/es6.object.assign')
require('core-js/modules/es6.array.fill')
require('core-js/modules/es6.array.find')
require('core-js/modules/es6.array.find-index')
require('core-js/modules/es6.string.starts-with')

// Promise support for async loading and AJAX
require('core-js/modules/es6.promise')

// We need Symbol support for some React optimizations
require('core-js/modules/es6.symbol')

require('core-js/modules/es7.array.includes')



// WEBPACK FOOTER //
// ./src/polyfills.js